<mat-expansion-panel #expansionPanel hideToggle>
  <footer *ngIf="isCollapsed" class="footer tw-flex tw-justify-between tw-box-border">
    <div class="footer__info tw-flex tw-justify-center tw-items-center tw-gap-x-8">
      <div class="intrack-logo"></div>
      <div class="app-version">{{ 'footer.appVersion' | translate }}: {{ appVersion }}</div>
      <div class="copyrights">
        {{ 'footer.copyrights' | translate : { year: currentYear } }}
      </div>
    </div>
    <div class="links-section">
      <span
        *ngFor="
          let menu of [
            {
              translationKey: 'footer.legalDocuments.imprint.title',
              link: '/dashboard/administration/legal-documents/imprint'
            },
            {
              translationKey: 'footer.legalDocuments.legalNotice.title',
              link: '/dashboard/administration/legal-documents/legal-notice'
            },
            {
              translationKey: 'footer.dependencyLicenses.title',
              link: '/dashboard/administration/dependency-licenses'
            },
            {
              translationKey: 'footer.dataProtectionNotice.title',
              link: '/dashboard/administration/data-protection-notice/default'
            },
            {
              translationKey: 'footer.termsAndConditions.title',
              link: '/dashboard/administration/end-user-license-agreement/default'
            }
          ]
        "
        class="link footer-text"
        routerLink="{{ menu.link }}"
      >
        {{ menu.translationKey | translate }}
      </span>
    </div>
  </footer>

  <mat-expansion-panel-header matRipple class="expansion-header">
    <footer class="footer tw-flex tw-justify-between tw-box-border">
      <span class="footer-text corporate-information tw-self-center">
        {{ 'footer.corporateInformation' | translate }}
      </span>
      <div class="links-section">
        <span class="footer-text collapsed-text">
          {{
            expansionPanel.expanded
              ? ('footer.collapsed.hideFooter' | translate)
              : ('footer.collapsed.showFooter' | translate)
          }}
        </span>
        <ui-svg-icon
          [name]="expansionPanel.expanded ? iconNames.Down : iconNames.Up"
          class="dropdown-icon"
        ></ui-svg-icon>
      </div>
    </footer>
  </mat-expansion-panel-header>
</mat-expansion-panel>
